/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerGetSegmentAdOverlayByDateQueryResponse, PntAppControllerGetSegmentAdOverlayByDatePathParams, PntAppControllerGetSegmentAdOverlayByDateQueryParams } from "../models/PntAppControllerGetSegmentAdOverlayByDate";

export function getPntAppControllerGetSegmentAdOverlayByDateUrl(slug: PntAppControllerGetSegmentAdOverlayByDatePathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/adoverlay` as const }
  return res
}

/**
 * @summary Retrieve the ad overlays for a time range
 * {@link /pnt/v2/segments/:slug/adoverlay}
 */
export async function pntAppControllerGetSegmentAdOverlayByDate(slug: PntAppControllerGetSegmentAdOverlayByDatePathParams["slug"], params: PntAppControllerGetSegmentAdOverlayByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntAppControllerGetSegmentAdOverlayByDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntAppControllerGetSegmentAdOverlayByDateUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}